export const MANDATORY_AUTHOR_SUBMISSION_FIELDS = [
  'Title',
  // 'Abstract',
  'Authors',
  'Manuscript',
  // 'Keywords',
  'SubmittingAuthor',
  'CorrespondingAuthor',
  //'TitlePage',
  'ExtractionSkipCheckbox',
  'ArticleType',
  'FocusIssue'
] as const;

export type MandatoryAuthorSubmissionField =
  (typeof MANDATORY_AUTHOR_SUBMISSION_FIELDS)[number];

export function assertMandatoryFieldsPresent(
  fields: Record<string, unknown>
): void {
  const missing = MANDATORY_AUTHOR_SUBMISSION_FIELDS.filter(
    name => !(name in fields)
  );

  if (missing.length === 0) return;

  throw Object.assign(new Error('Missing mandatory form fields'), {
    status: 400,
    body: {
      errors: missing.map(name => ({
        field: name,
        message:
          'This field is mandatory and cannot be removed from any article type'
      }))
    }
  });
}
